export enum TimePeriodBeginEnum {
    Begins_On_Month = 'Begins on a month',
    Begins_On_Onboarding_Date = 'Begins on month following onboarding date',
}
